define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const core = require('core');
    const user = require('user');
    const config = require('config');
    const LoginView = require('portlets/login/login.view');
    const tmpl = require('tmpl');
    const i18n = require('i18n');
    const formatter = require('common/formatter');
    const server = require('server');
    const Form = require('class/form.class');
    const BaseView = require('common/base.view');
    const getDynamicTagValue = require('../../../util/swiss-theme/dynamicTag.value.util');
    const trackingTag = require('util/swiss-theme/trackingTag.util');

    module.exports = LoginView.extend({
        render: function() {
            const popupInnerClass = this.el.parentElement.classList;
            const fromEmailVerification = localStorage.getItem('emailVerificationNotification');
            const fromForgotPass = localStorage.getItem('forgotPassToken');
            const username = localStorage.getItem('username');
            const userEmailFromReg = localStorage.getItem('userEmailFromReg');
            const userNameEl = $('input[name="userName"]')?.length && $('input[name="userName"]')?.[0];
            this.userEmailFromReg = userNameEl.value;

            this.$el.html(this.tmpl(this.formTemplate, {
                isFitToPlaySubmissionRequired: Playtech.API.auth.getFitToPlaySubmissionRequired(),
                isRememberMeSupported: this.isRememberMeSupported,
                isRememberDeviceSupported: this.isRememberDeviceSupported,
                upperCase: config.get('isUsernameInUppercase')
            }));

            this.form = new Form(this.$('.fn-login'), this.getTmplData());
            popupInnerClass.contains('popup-modal__inner-content') && popupInnerClass.add('popup_type_login');
            const emailVerificationDiv = document.getElementById('emailVerifyMessage');
            const continueLoginBtn = window.document.getElementsByClassName('continueLoginBtn')[0];
            const loginBtn = window.document.getElementsByClassName('loginBtn')[0];
            const passwordField = window.document.getElementsByClassName('field_name_password')[0];

            this.passwordFieldLabelHandler(passwordField);

            const showPasswordField = () => {
                continueLoginBtn?.classList?.add('hidden');
                loginBtn?.classList?.remove('hidden');
                passwordField?.classList?.remove('hidden');
            };

            if ((fromEmailVerification || fromForgotPass || userEmailFromReg) || this.userEmailFromReg) {
                const userName = fromEmailVerification ? username : fromForgotPass ? fromForgotPass : userEmailFromReg || this.userEmailFromReg;
                const userNameEl = $('input[name="userName"]');
                const userNameField = $('.field_name_username');
                const labelUserName = userNameField.find('.floating-label');

                fromEmailVerification && this.showMessageInPopup(fromEmailVerification);

                if (userNameEl.length) {
                    userNameEl[0].value = userName;
                }

                userNameField && userNameField[0].classList.add('valid');
                labelUserName && labelUserName.addClass('label-above');

                if (fromEmailVerification) {
                    localStorage.removeItem('emailVerificationNotification');
                    localStorage.removeItem('username');
                } else if (fromForgotPass) {
                    localStorage.removeItem('forgotPassToken');
                } else {
                    localStorage.removeItem('userEmailFromReg');
                    this.userEmailFromReg = null;
                    showPasswordField();
                    passwordField.querySelector('input')?.focus();
                }
            }

            if (emailVerificationDiv && emailVerificationDiv?.querySelector('p') !== null) {
                const paragraph = emailVerificationDiv.querySelector('p');

                if (paragraph.textContent.trim() !== '') {
                    showPasswordField();
                }
            }

            if (window.localStorage.getItem('loginPopupComesFrom') === 'forgotPass') {
                showPasswordField();
            }

            const cBtn = window.document.querySelector('.continueLoginBtn');
            const passField = window.document.querySelector('.field_name_password');

            if (cBtn && passField) {
                cBtn.addEventListener('click', function() {
                    const passwordInput = document.querySelector('input[name="password"]');

                    if (passwordInput) {
                        passwordInput.focus();
                    }
                });
            }

            return this;
        },

        // This handler is needed for IOS autofill functionality
        passwordFieldLabelHandler: function(passwordField) {
            const targetInput = passwordField.querySelector('input');

            const updatePassFieldLabel = (value, fieldElement) => {
                if (!fieldElement) {
                    return;
                }

                if (value) {
                    fieldElement.querySelector('.floating-label').classList.add('label-above');
                } else {
                    fieldElement.querySelector('.floating-label').classList.remove('label-above');
                }
            };

            const nativeDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

            if (targetInput) {
                Object.defineProperty(targetInput, 'value', {
                    set: function(newValue) {
                        nativeDescriptor.set.call(this, newValue);

                        targetInput.focus();
                        updatePassFieldLabel(newValue, passwordField);
                    },
                    get: function() {
                        return nativeDescriptor.get.call(this);
                    }
                });
            }
        },

        showMessageInPopup : function(isError) {
            const trKey = 'playtech.mobile.system.emailVerification.loginMessage.';
            const el = $('#emailVerifyMessage');
            isError = isError === 'false' ? false : true;

            el.html(tmpl['common.messages']({
                className: isError ? 'error' : 'verify-success',
                content: i18n.translate(trKey + (isError ? 'error' : 'success'))
            }));

            return this;
        },

        errorLogin: function(response) {
            const templateId = config.get('emailverifiedbeforelogin') || 'Test GICE - Emailverifiedbeforelogin';
            const data = response.data;
            const errorTemplates = getDynamicTagValue('LOGIN_ERRORS_TEMPLATE_ID')?.split(',');
            const isErrorTemplate = errorTemplates.some(el => el === data?.actions?.PlayerActionShowMessage?.[0]?.templateId);
            const getMessageFromActions = function(actions, isNotAgreedEmail) {
                const messages = actions && actions.PlayerActionShowMessage || [];
                let result;

                if (isNotAgreedEmail && messages[0] && messages[0].message) {
                    result = messages[0].message.substr(messages[0].message.indexOf("|") + 1);
                } else {
                    result = messages[0] && messages[0].message;
                }

                return result;
            };

            if (this.form.data('userName')) {
                this.form.el.elements.password.focus();
            } else {
                this.form.el.elements.userName.focus();
            }

            if (!data) {
                return;
            }

            if (data.errorCode === 301) {
                this.showSubmitRecaptcha({
                    onError: err => this.form.showErrorMessage(err)
                });

                return;
            }

            if (data.errorCode === 0) {
                return;
            }

            const spareMessage = data.errorText || data.errorMessage || data.playerMessage;
            let isPlayerActionShowMessage;

            if (data.actions && data.actions.PlayerActionShowMessage) {
                isPlayerActionShowMessage = data.actions.PlayerActionShowMessage.filter(function(message) {
                    return message.templateId === templateId;
                }).length;
            }

            this.form.showErrorMessage({
                className: data.errorCode === 48 && isPlayerActionShowMessage ? 'verify-success verify-email' : 'error',
                translation: data.errorCode === 48 ?
                    isPlayerActionShowMessage ? getMessageFromActions(data.actions, true) || spareMessage :
                        isErrorTemplate ? getMessageFromActions(data.actions) || spareMessage :
                            'playtech.mobile.system.login.error.' + data.errorCode :
                    'playtech.mobile.system.login.error.' + data.errorCode,
                content: getMessageFromActions(data.actions, isPlayerActionShowMessage) || spareMessage
            });

            if ($('.message.verify-success') && $('.message.error') && isPlayerActionShowMessage) {
                $('.error').hide();
            }
        },

        successLogin: function() {
            this.hideKeyboard();
            this.afterLoginActionSwiss();
            user.storeRememberMeItem();

            if (this.options.isRefreshPage) {
                core.trigger('page:refresh');
            }
        },

        getCookie: function(name) {
            const cookies = window.document.cookie.split(';');

            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].trim();

                if (cookie.indexOf(name + '=') === 0) {
                    return cookie.substring(name.length + 1);
                }
            }

            return null;
        },

        afterLoginActionSwiss: function() {
            const getStatus = async () => {
                return await window.Playtech.sendUserRegulationStatusRequest();
            };

            const cookieName = 'at_gd_cookie';
            const cookieValue = this.getCookie(cookieName);
            let regStatus;

            trackingTag({ shouldCheckTagFromServer: true });

            getStatus().then(result => {
                regStatus = result?.data?.playerRegulationStatusHistory?.[0]?.code;
                if (cookieValue !== null && cookieValue !== '' && regStatus === 'CHE-1') {
                    server.send({
                        ID: 35881,
                        responses: [35882, 35883],
                        description: 'Search Player Logins',
                        pagingParams: {
                            returnAllPageIds: false,
                            pageSize: 1,
                            returnTotalCount: true,
                            pageId: 1
                        },
                        loginCriteria: {
                            loginDateBeforeDate: formatter.getDateTimeLongMs(Date.now())
                        }
                    }).done((response) => {
                        if (response.data?.pagingParams?.totalCount <= 1) {
                            server.send({
                                ID: 35544,
                                responses: [35545, 35546],
                                description: 'Set player tags',
                                tags: [{
                                    'name': 'sc/tracking/adtraction',
                                    'value': cookieValue,
                                    'type': 'text'
                                }]
                            }).done(() => {
                                // Delete the cookie
                                document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
                            }).fail(() => {
                                console.log('Get Player logins count Request fail');
                            });
                        }
                    }).fail(() => {
                        console.log('Set Affiliate Tag Request fail');
                    });
                }
            }).catch(error => {
                console.error(error);
            });
        },

        login: function(event) {
            const token = user.get('userAvailabilityVerificationToken');

            Playtech.API.server.checkIfUsernameIsAvailable({
                email: event.target[0].value,
                userName: event.target[0].value,
                casinoName: Playtech.Variables.casinoName,
                ...token && { token }
            }).then((data)=> {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                let isEmail = emailRegex.test(event.target[0]?.value);
                const { emailAvailable, usernameAvailable } = data;

                if (isEmail && (emailAvailable === 'available' || emailAvailable === 'unknown')) {
                    // Get items on registration page after render
                    window.sessionStorage.setItem('emailLogin', event.target[0].value);
                    window.sessionStorage.removeItem('usernameLogin');
                    core.navigate('/register');
                } else if (!isEmail && usernameAvailable === true) {
                    // Get items on registration page after render
                    window.sessionStorage.setItem('usernameLogin', event.target[0].value);
                    window.sessionStorage.removeItem('emailLogin');
                    core.navigate('/register');
                } else {
                    const $field = this.$('.field_name_password');
                    const element = window.document.getElementsByClassName('field_name_password')[0];
                    const userNameField = window.document.getElementsByClassName('field_name_username')[0];
                    const continueLoginBtn = window.document.getElementsByClassName('continueLoginBtn')[0];
                    const loginBtn = window.document.getElementsByClassName('loginBtn')[0];

                    if (!continueLoginBtn?.classList?.contains('hidden')) {
                        this.form.resetField($field);
                        const active = element?.querySelector('.field__control');
                        active && active?.classList?.add('active-input-field');
                    }

                    if (userNameField && userNameField?.classList?.contains('invalid')) {
                        this.form.resetField($field);
                    }

                    event?.target[0]?.value !== '' && event?.target[0]?.value?.length > 4 && element?.classList?.remove('hidden');
                    !continueLoginBtn?.classList?.contains('hidden') && element?.querySelector('input').focus();
                    event?.target[0]?.value !== '' && event?.target[0]?.value?.length > 4 && continueLoginBtn?.classList?.add('hidden');
                    event?.target[0]?.value !== '' && event?.target[0]?.value?.length > 4 && loginBtn?.classList?.remove('hidden');
                }
            }).catch(function(error) {
                console.log(error);
            });

            if (event) {
                event.preventDefault();
            }

            const loginState = $.Deferred();
            const recaptchaError = this.getRecaptchaError();

            if (recaptchaError) {
                this.form.showErrorMessage(recaptchaError);
                loginState.reject();
            } else {
                this.form.validate()
                    .done(function(data, form) {
                        form.showLoading();

                        user.set(this.getLoginParams(data));

                        this.password = data.password;

                        user
                            .fetch()
                            .always(function() {
                                form.hideLoading();
                                user.removePassword();
                            })
                            .done(function() {
                                this.successLogin.apply(this, arguments);
                                loginState.resolve();
                            }.bind(this))
                            .fail(function(error) {
                                if (error?.data?.isPrevented) {
                                    // do not resolve or reject here
                                    // otherwise, native app will receive reset
                                    return;
                                }

                                this.errorLogin.apply(this, arguments);
                                loginState.reject(error);
                            }.bind(this));
                    }.bind(this))
                    .fail(function() {
                        this.errorLogin({
                            data: {
                                errorCode: 0
                            }
                        });
                    }.bind(this));
            }

            return loginState.promise();
        },

        close: function() {
            window.fidoAuth.abortCurrent();
            window.localStorage.removeItem('loginPopupComesFrom'); // For login btn display from forgotpass popup
            $(window).off('.login');

            BaseView.prototype.close.apply(this, arguments);
        },

        getTmplData: function() {
            return {
                validationConfig: {
                    userName: {
                        length: {
                            min: 5,
                            max: 9007199254740992,
                            message: i18n.t('playtech.mobile.system.user.tooltip.userNameOnLogin.length')
                        },
                        required: true
                    },
                    password: {
                        required: true
                    },
                    fitToPlay: {
                        required: Playtech.API.auth.getFitToPlaySubmissionRequired()
                    }
                }
            };
        }
    });
});
